var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.departments)?_c('DepartmentList',{attrs:{"items":_vm.departments,"headerField":"deptName","childrenField":"children","hasChildrenField":(item) => item.hasChildren === 'TRUE'},on:{"selectItem":_vm.selectItem,"select":_vm.toggleDepartmentAsync}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }